import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, LocalService, PageKey, Wrapper10Initialization } from '../../../service/local.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { AuditingService } from 'src/service/auditing.service';

@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styleUrl: './expenses.component.scss'
})
export class ExpensesComponent {
  lstSectionConfigKeys: string[] = ["tasks", "table"];
  userId: string = ''; ctryCode: string = ''; interactionType = InteractionType.None; maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private auditingService: AuditingService, private languageManagementService: LanguageManagementService, private router: Router, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.configurationManagementService.ensurePageActions(PageKey.Expenses);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onInitiate();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {

  }
}
